import React from 'react';
import Helmet from 'react-helmet';
import styled, { injectGlobal } from 'styled-components';

import LandingPageStyles from '../../styles/LandingPageStyles';

import LandingHeader from '../LandingHeader/LandingHeader';
import LandingFooter from '../LandingFooter/LandingFooter';
import ThankYouMessage from './ThankYouMessage';
import ScriptTags from '../ScriptTags';
import UrlUtility from '../../utils/UrlUtility';
import { onHelmetChangeClientState, send} from '../../utils/Analytics';

injectGlobal`
  html {
      /* - DESKTOP VIEW - */
      @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        min-height: 600px;
      }
      
      /* - TABLET VIEW - */
      @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        min-height: 600px;
      }

      /* - MOBILE VIEW - */
      @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        min-height: 550px;
      }
  }
`;

const ThankYouPageContainer = styled.div`
    height: 100%;
    width: 100%;

    &.main-content {
        display: block;
    }

    .script-tags {
        display: none;
    }
`;

const ThankYouPage = ({
    gaEventLabel,
    tyType,
    blurbType,
    isQuiz,
    originWebFormCategory
}) => {

    let subscriberNoScript = (
        <noscript>
            <img src="https://7191.xg4ken.com/pixel/v1?track=1&token=af9a1df0-aa7a-45a6-aed0-
                4fbc1437b7df&conversionType= Clayton_PPC_ Subscriber&revenue=0.0&currency=USD&orderId=&promoCode="
                width="1" height="1" />
            <img src="https://ad.doubleclick.net/ddm/activity/src=6346097;type=fall1000;cat=fall10;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
        </noscript>
    );

    let leadNoScript = (
        <noscript>
            <img src="https://7191.xg4ken.com/pixel/v1?track=1&token=af9a1df0-aa7a-45a6-aed0-
            4fbc1437b7df&conversionType= Clayton_PPC_LeadForm&revenue=0.0&currency=USD&orderId=&promoCode="
            width="1" height="1" />
            <img src="https://ad.doubleclick.net/ddm/activity/src=6346097;type=fall1000;cat=clay-0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
        </noscript>
    );

    let marketingReadyNoScript = (
        <noscript>
            <img src="https://7191.xg4ken.com/pixel/v1?track=1&token=af9a1df0-aa7a-45a6-aed0-4fbc1437b7df&conversionType= Clayton_PPC_ MarketingReady&revenue=0.0&currency=USD&orderId=&promoCode=" width="1" height="1" />
            <img src="https://ad.doubleclick.net/ddm/activity/src=6346097;type=fall1000;cat=clay-0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" alt=""/>
        </noscript>
    );

    let leadScript = `
        if (typeof gtag !== 'undefined'){
            gtag('event', 'conversion', {
                'allow_custom_scripts': true,
                'send_to': 'DC-6346097/fall1000/clay-0+standard'
            });
            gtag('event', 'conversion', {
                'send_to': 'AW-1040796449/hvHFCOGT6QEQoZal8AM',
                'value': 1.0,
                'currency': 'USD'
                });
        }
        if (typeof fbq !== 'undefined'){
            fbq('track', 'Lead');
        }
        if (typeof kenshoo !== 'undefined'){
            kenshoo.trackConversion('7191','af9a1df0-aa7a-45a6-aed0-4fbc1437b7df',{
                /*OPTIONAL PARAMETERS. FILL VALUES OR REMOVE UNNEEDED PARAMETERS*/
                conversionType: 'Clayton_PPC_LeadForm',
                revenue: 0.0,
                currency:'USD',
                orderId:'',
                promoCode:'' });
        }
    `

    let subscriberScript = `
        if (typeof gtag !== 'undefined'){
            gtag('event', 'conversion', {
                'allow_custom_scripts': true,            
                'send_to': 'DC-6346097/fall1000/fall10+standard'            
            });
            gtag('event', 'conversion', {'send_to': 'AW-1040796449/bMEMCMqt_4UBEKGWpfAD'});  
        }
        if (typeof fbq !== 'undefined'){
            fbq('trackCustom', 'Subscriber');
        }
        if (typeof kenshoo !== 'undefined'){
            kenshoo.trackConversion('7191','af9a1df0-aa7a-45a6-aed0-4fbc1437b7df',{
                /*OPTIONAL PARAMETERS. FILL VALUES OR REMOVE UNNEEDED PARAMETERS*/
                conversionType: 'Clayton_PPC_Subscriber',
                revenue: 0.0,
                currency:'USD',
                orderId:'',
                promoCode:'' });
        }
    `


    //Check if lead form by whether or not we get zip param back (Indicator of lead gen for thank you message.)
    let isLead = UrlUtility.getValue("zip");

    let scriptTag = (isLead) ? leadScript : subscriberScript;
    let noScriptTag = (isLead) ? leadNoScript : subscriberNoScript;

    if (isQuiz) {
        scriptTag = leadScript;
        noScriptTag = leadNoScript;
    }

    if (originWebFormCategory === 'affordable') {
        scriptTag += `
            if (ga) {
                ga('send', 'event', 'HIM2018', 'Form Submit', 'Affordability - Form Submit');
            }`;
    } else if (originWebFormCategory === 'quality'){
        scriptTag += `
            if (ga) {
                ga('send', 'event', 'HIM2018', 'Form Submit', 'Quality - Form Submit');
            }`;
    } else if (originWebFormCategory === 'style'){
        if (isQuiz) {
            scriptTag += `
                if (ga) {
                    ga('send', 'event', 'HIM2018', 'Form Submit', 'Quiz Results - Form Submit');
                }`;
        } else {
            scriptTag += `
                if (ga) {
                    ga('send', 'event', 'HIM2018', 'Form Submit', 'Style - Form Submit');
                }`;
        }
    }

    return (
        <ThankYouPageContainer className="main-content">
            <LandingHeader />
            <ThankYouMessage 
                gaEventLabel={gaEventLabel} 
                tyType={tyType} 
                blurbType={blurbType}
            />
            <LandingFooter />

            <ScriptTags />

            {noScriptTag}
        
            <Helmet 
                  onChangeClientState={onHelmetChangeClientState}
                  script={[
                  {
                    type: 'text/javascript',
                    innerHTML: scriptTag,
                  }
                  ]}
				>
			</Helmet>
        </ThankYouPageContainer>
    );
}

export default ThankYouPage;


// WEBPACK FOOTER //
// ./src/components/ThankYou/ThankYouPage.js